import { collection, query, where, getDocs, addDoc, updateDoc, doc } from "firebase/firestore";
import { db } from "../utils/dbConnection";

export async function insertTodayDetails(weight, calories, pickedDate) {
  const date = pickedDate || new Date().toLocaleDateString();

  const trackerRef = collection(db, "DayTracker");
  const q = query(trackerRef, where("date", "==", date));
  const snapshot = await getDocs(q);

  if (!snapshot.empty) {
    // Document exists, update the first match
    const existingDoc = snapshot.docs[0];
    const docRef = doc(db, "DayTracker", existingDoc.id);

    await updateDoc(docRef, {
      weight,
      calories,
    });

    console.log("Updated existing entry:", existingDoc.id);
  } else {
    // Document doesn't exist, insert a new one
    const docRef = await addDoc(trackerRef, {
      date,
      weight,
      calories,
    });

    console.log("Inserted new entry:", docRef.id);
  }
}

export async function insertFoodDetails(name, calories) {
  const docRef = await addDoc(collection(db, "Food"), {
    name: name,
    calories: calories,
  });
  console.log("Document written with ID: ", docRef.id);
}
